// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__ApScI","Logo":"Toolbar_Logo__3Lk47","DesktopOnly":"Toolbar_DesktopOnly__LuPaL"};